import {Grid, Integer, ValueByDevice} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {TestIdProps, suffixTestId} from 'shared/web';

import {WORKSHOP_SECTION_APPEARANCE} from './constants/workshopSectionAppearance';
import {WorkshopOverviewDensity} from './types/WorkshopOverviewDensity';
import {WorkshopOverviewInteraction} from './types/WorkshopOverviewInteraction';
import {WorkshopOverviewTileState, WorkshopSection} from './types/WorkshopOverviewTileConfig';
import {WorkshopOverviewTile} from './WorkshopOverviewTile';

interface WorkshopOverviewTileGridProps extends TestIdProps {
  section: WorkshopSection;
  tiles: WorkshopOverviewTileState[];
  density: WorkshopOverviewDensity;
  interaction: WorkshopOverviewInteraction;
  grow?: number;
}

interface WorkshopOverviewTileGridLayout {
  columns: ValueByDevice<number>;
  spacing: Integer;
}

const GRID_LAYOUT: Record<WorkshopOverviewDensity, WorkshopOverviewTileGridLayout> = {
  comfortable: {columns: [1, 2, 1, 2], spacing: 3},
  compact: {columns: [1, 2, 2, 2], spacing: 2},
};

export function WorkshopOverviewTileGrid(props: WorkshopOverviewTileGridProps) {
  const layout = GRID_LAYOUT[props.density];
  const appearance = WORKSHOP_SECTION_APPEARANCE[props.section];

  return (
    <Grid columns={layout.columns} spacing={layout.spacing} grow={props.grow}>
      {props.tiles.map((tileState) => (
        <WorkshopOverviewTile
          key={tileState.tile.id}
          tile={tileState.tile}
          count={tileState.count}
          density={props.density}
          isPending={props.interaction.pendingTileId === tileState.tile.id}
          isDisabled={
            isNotNil(props.interaction.pendingTileId) &&
            props.interaction.pendingTileId !== tileState.tile.id
          }
          appearance={appearance}
          interaction={props.interaction}
          data-testid={suffixTestId(`workshopOverviewTile-${tileState.tile.id}`, props)}
        />
      ))}
    </Grid>
  );
}
